// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

body {
  background-color: #ffffff;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.header-campo-nombre {
	color: #ffffff;
  font-weight: 800;
	font-size: 17px;
}

.header-campo-valor {
	color: #ffffff;
	font-size: 14px;
	font-weight: 500;
}

div#root {
  height: 100%;
}

.Boorrar .navbar {
  background-color: #16203b;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.login-error {
  background-color: rgb(255, 61, 61);
  color: white;
  text-align: center;
  padding: 5px;
}

/*.Boorrar .table-data>thead>tr {
}  Esta parte estaba vacia,al parecer no hace nada  */

.table-data>thead>tr>th {
  padding: 5px;
  background-color: #232d32;
  color: #ffffff;
  font-weight: bold;
}

.table-data>tbody>tr {
  padding: 2px;
}

.table-data>tbody>tr>td {
  padding: 2px;
}

.detalle .detalle-titulo {
  background-color: #444949;
  color: #ffffff;
  font-weight: bold;
  padding: 4px;
}

.detalle .detalle-valor {
  background-color: #d4d4d4;
  color: #000000;
  padding: 4px;
}

.detalle .sub-detalle-titulo {
  background-color: #6e6e6e;
  color: #ffffff;
  font-weight: bold;
  padding: 4px;
}

.detalle .sub-detalle-valor {
  background-color: #f3f3f3;
  color: #000;
  padding: 4px;
}

.fila_deposito_manual {
  background-color: #84dfd6;
}

.recaudo-diferencia {
  background-color: #ee8989;
  color: #ffffff;
}

.recaudo-diferencia {
  background-color: #da9696 !important;
  color: #ffffff !important;
}

.AppBar {
  background-color: #212d4b !important;
}

.MainDrawer {
  /*este*/
  background-color: #000000 !important;
}

.MainDrawerPaper {
  background-color: #6A9E2C !important;
}

.MainDrawerHeader {
  background-color: #6A9E2C !important;
}

.MainDrawerToolbar {
  background-color: #6A9E2C !important;
  
}

.MainMenu {
  background-color: #d9d9d9ff !important;
  color: #434343!important;
}

.MainMenu:hover {
  background-color: #5e5e5e83 !important;
  color: #000000 !important;
  font-weight: bold;
}


.MainMenuItem {
  background-color:  #ccccccff !important;
  color: #434343 !important;
  border-bottom: 1px solid #101f1400 !important;
}

/** 
*! .MainMenu {
  background-color: #335e8d !important;
  color: #ffffff !important;
}

*!.MainMenuItem { 
  background-color: #5791cf !important;
  color: #ffffff !important;
  border-bottom: 1px solid #4675a8 !important;
}*/

/**
  * ? Aca Esta la sección  en la que se cambia el tamañp del logo 
  * TODO: Tengo que cambiar el logo por uno con la S pero no puede afectar el logo completo en la entrada 
*/
.MainMenuItemIcon {
  min-width: 40px !important;
}

.MainMenuItem.Mui-selected {
  background-color: #04471B !important;
  color: #434343  !important;
}

.MainMenuItem.Mui-selected:hover {
  background-color: rgb(165, 165, 165)  !important;
  color: #434343  !important;
}

.MainMenuItem:hover {
  background-color: #04471B !important;
  color: #ffffff !important;
}

.MainMenuItemIcon {
  color: #000000bb !important;
  min-width: 40px;
}

.ItemLista {
  margin: 1px !important;
  padding: 10px !important;
  background-color: #434343!important;
  color: #ffffff !important;
}

/*.TablaEstados {
	
}*/

.TablaEstados th {
	font-size: 13px; 
}

.TablaEstados tr td {
	padding: 0px;
	font-size: 14px;
}

.divCambiarPassword {
	background-color: #f66151;
	border: 1px solid #ff0000;
	padding: 5px;
	font-size: 17px;
	color: #ffffff;
	text-align: center;
}


/* =========================================
   Sidebar (Drawer) — paleta azul marino + acento verde
   ========================================= */

.MainDrawer, .MainDrawerPaper {
  background-color: #1b2440 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.04) !important;
  color: #d8dde6 !important;
}

.MainDrawerHeader {
  background-color: #1b2440 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
  padding: 6px 8px !important;
}

.MainDrawerHeader .MuiIconButton-root,
.MainDrawerHeader .MuiSvgIcon-root {
  color: rgba(255, 255, 255, 0.7) !important;
}

.MainDrawerToolbar {
  background-color: #1b2440 !important;
}

.AppBar {
  background-color: #212d4b !important;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) !important;
}

.AppBar .MuiSvgIcon-root,
.AppBar .MuiIconButton-root {
  color: #ffffff !important;
}

.MainDrawer .MuiList-root {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

/* Botón principal (categoría colapsable) */
.MainMenu {
  background-color: transparent !important;
  color: #e3e7ee !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  transition: background-color 180ms ease, color 180ms ease !important;
  position: relative;
}

.MainMenu:hover {
  background-color: rgba(140, 198, 62, 0.10) !important;
  color: #ffffff !important;
}

.MainMenu .MuiListItemText-primary {
  font-size: 0.92rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
}

/* Item del menú (submenú o item directo) */
.MainMenuItem {
  background-color: transparent !important;
  color: #bcc4d2 !important;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  border-bottom: none !important;
  transition: background-color 180ms ease, color 180ms ease !important;
  position: relative;
}

.MainMenuItem:hover {
  background-color: rgba(140, 198, 62, 0.08) !important;
  color: #ffffff !important;
}

.MainMenuItem.Mui-selected {
  background-color: rgba(140, 198, 62, 0.16) !important;
  color: #ffffff !important;
}

.MainMenuItem.Mui-selected:hover {
  background-color: rgba(140, 198, 62, 0.22) !important;
  color: #ffffff !important;
}

/* Acento verde a la izquierda del item activo */
.MainMenuItem.Mui-selected::before {
  content: '';
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 0;
  width: 3px;
  background-color: #8CC63E;
  border-radius: 0 4px 4px 0;
}

.MainMenuItem .MuiListItemText-primary {
  font-size: 0.85rem !important;
  font-weight: 500 !important;
}

/* Iconos — color por sección, ver más abajo */
.MainMenuItemIcon {
  color: #8CC63E !important;
  min-width: 38px !important;
  transition: color 180ms ease, filter 180ms ease !important;
}

.MainMenu:hover .MainMenuItemIcon,
.MainMenuItem:hover .MainMenuItemIcon {
  filter: brightness(1.2);
}

/* Paleta por categoría (coincide con tarjetas de Inicio) */
.cat-inicio .MainMenuItemIcon         { color: #8CC63E !important; }
.cat-reportes .MainMenuItemIcon       { color: #6A9E2C !important; }
.cat-transacciones .MainMenuItemIcon  { color: #7E57C2 !important; }
.cat-monitoreo .MainMenuItemIcon      { color: #2E7DD7 !important; }
.cat-cajeros .MainMenuItemIcon        { color: #E07A1F !important; }
.cat-server .MainMenuItemIcon         { color: #00897B !important; }
.cat-funcionarios .MainMenuItemIcon   { color: #78909C !important; }
.cat-depositantes .MainMenuItemIcon   { color: #F4B400 !important; }
.cat-billetera .MainMenuItemIcon      { color: #C2185B !important; }
.cat-administracion .MainMenuItemIcon { color: #7E5BEF !important; }
.cat-cuenta .MainMenuItemIcon         { color: #00ACC1 !important; }

/* Divisores sutiles para las secciones (cuando MainLayout aplica borderTop inline) */
.MainDrawer .MuiList-root[style*="border-top"],
.MainDrawer .MuiList-root[style*="border-bottom"] {
  border-color: rgba(255, 255, 255, 0.06) !important;
}

/* Chevrons de expandir/colapsar */
.MainMenu .MuiSvgIcon-root[data-testid="ExpandMoreIcon"],
.MainMenu .MuiSvgIcon-root[data-testid="ExpandLessIcon"] {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* Versión */
.MainDrawerVersion {
  color: rgba(255, 255, 255, 0.4) !important;
  font-size: 0.72rem !important;
  letter-spacing: 0.06em;
  text-align: center;
  padding: 12px 0 14px !important;
  margin: 0 !important;
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;CACC,cAAc;EACb,gBAAgB;CACjB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;qDACqD;;AAErD;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,iBAAiB;AACnB;;;AAGA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;;;;;;;;;EAUE;;AAEF;;;CAGC;AACD;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;;EAEE;;AAEF;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;;AAGA;;8CAE8C;;AAE9C;EACE,oCAAoC;EACpC,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,2CAA2C;AAC3C;EACE,wCAAwC;EACxC,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,wCAAwC;EACxC,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;AACnE,wCAAwC,yBAAyB,EAAE;;AAEnE,qFAAqF;AACrF;;EAEE,kDAAkD;AACpD;;AAEA,kCAAkC;AAClC;;EAEE,0CAA0C;AAC5C;;AAEA,YAAY;AACZ;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;AACtB","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  background-color: #ffffff;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: 100%;\n}\n\n.header-campo-nombre {\n\tcolor: #ffffff;\n  font-weight: 800;\n\tfont-size: 17px;\n}\n\n.header-campo-valor {\n\tcolor: #ffffff;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\ndiv#root {\n  height: 100%;\n}\n\n.Boorrar .navbar {\n  background-color: #16203b;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.login-error {\n  background-color: rgb(255, 61, 61);\n  color: white;\n  text-align: center;\n  padding: 5px;\n}\n\n/*.Boorrar .table-data>thead>tr {\n}  Esta parte estaba vacia,al parecer no hace nada  */\n\n.table-data>thead>tr>th {\n  padding: 5px;\n  background-color: #232d32;\n  color: #ffffff;\n  font-weight: bold;\n}\n\n.table-data>tbody>tr {\n  padding: 2px;\n}\n\n.table-data>tbody>tr>td {\n  padding: 2px;\n}\n\n.detalle .detalle-titulo {\n  background-color: #444949;\n  color: #ffffff;\n  font-weight: bold;\n  padding: 4px;\n}\n\n.detalle .detalle-valor {\n  background-color: #d4d4d4;\n  color: #000000;\n  padding: 4px;\n}\n\n.detalle .sub-detalle-titulo {\n  background-color: #6e6e6e;\n  color: #ffffff;\n  font-weight: bold;\n  padding: 4px;\n}\n\n.detalle .sub-detalle-valor {\n  background-color: #f3f3f3;\n  color: #000;\n  padding: 4px;\n}\n\n.fila_deposito_manual {\n  background-color: #84dfd6;\n}\n\n.recaudo-diferencia {\n  background-color: #ee8989;\n  color: #ffffff;\n}\n\n.recaudo-diferencia {\n  background-color: #da9696 !important;\n  color: #ffffff !important;\n}\n\n.AppBar {\n  background-color: #212d4b !important;\n}\n\n.MainDrawer {\n  /*este*/\n  background-color: #000000 !important;\n}\n\n.MainDrawerPaper {\n  background-color: #6A9E2C !important;\n}\n\n.MainDrawerHeader {\n  background-color: #6A9E2C !important;\n}\n\n.MainDrawerToolbar {\n  background-color: #6A9E2C !important;\n  \n}\n\n.MainMenu {\n  background-color: #d9d9d9ff !important;\n  color: #434343!important;\n}\n\n.MainMenu:hover {\n  background-color: #5e5e5e83 !important;\n  color: #000000 !important;\n  font-weight: bold;\n}\n\n\n.MainMenuItem {\n  background-color:  #ccccccff !important;\n  color: #434343 !important;\n  border-bottom: 1px solid #101f1400 !important;\n}\n\n/** \n*! .MainMenu {\n  background-color: #335e8d !important;\n  color: #ffffff !important;\n}\n\n*!.MainMenuItem { \n  background-color: #5791cf !important;\n  color: #ffffff !important;\n  border-bottom: 1px solid #4675a8 !important;\n}*/\n\n/**\n  * ? Aca Esta la sección  en la que se cambia el tamañp del logo \n  * TODO: Tengo que cambiar el logo por uno con la S pero no puede afectar el logo completo en la entrada \n*/\n.MainMenuItemIcon {\n  min-width: 40px !important;\n}\n\n.MainMenuItem.Mui-selected {\n  background-color: #04471B !important;\n  color: #434343  !important;\n}\n\n.MainMenuItem.Mui-selected:hover {\n  background-color: rgb(165, 165, 165)  !important;\n  color: #434343  !important;\n}\n\n.MainMenuItem:hover {\n  background-color: #04471B !important;\n  color: #ffffff !important;\n}\n\n.MainMenuItemIcon {\n  color: #000000bb !important;\n  min-width: 40px;\n}\n\n.ItemLista {\n  margin: 1px !important;\n  padding: 10px !important;\n  background-color: #434343!important;\n  color: #ffffff !important;\n}\n\n/*.TablaEstados {\n\t\n}*/\n\n.TablaEstados th {\n\tfont-size: 13px; \n}\n\n.TablaEstados tr td {\n\tpadding: 0px;\n\tfont-size: 14px;\n}\n\n.divCambiarPassword {\n\tbackground-color: #f66151;\n\tborder: 1px solid #ff0000;\n\tpadding: 5px;\n\tfont-size: 17px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n\n/* =========================================\n   Sidebar (Drawer) — paleta azul marino + acento verde\n   ========================================= */\n\n.MainDrawer, .MainDrawerPaper {\n  background-color: #1b2440 !important;\n  border-right: 1px solid rgba(255, 255, 255, 0.04) !important;\n  color: #d8dde6 !important;\n}\n\n.MainDrawerHeader {\n  background-color: #1b2440 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;\n  padding: 6px 8px !important;\n}\n\n.MainDrawerHeader .MuiIconButton-root,\n.MainDrawerHeader .MuiSvgIcon-root {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.MainDrawerToolbar {\n  background-color: #1b2440 !important;\n}\n\n.AppBar {\n  background-color: #212d4b !important;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) !important;\n}\n\n.AppBar .MuiSvgIcon-root,\n.AppBar .MuiIconButton-root {\n  color: #ffffff !important;\n}\n\n.MainDrawer .MuiList-root {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n/* Botón principal (categoría colapsable) */\n.MainMenu {\n  background-color: transparent !important;\n  color: #e3e7ee !important;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n  transition: background-color 180ms ease, color 180ms ease !important;\n  position: relative;\n}\n\n.MainMenu:hover {\n  background-color: rgba(140, 198, 62, 0.10) !important;\n  color: #ffffff !important;\n}\n\n.MainMenu .MuiListItemText-primary {\n  font-size: 0.92rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.02em;\n}\n\n/* Item del menú (submenú o item directo) */\n.MainMenuItem {\n  background-color: transparent !important;\n  color: #bcc4d2 !important;\n  padding-top: 7px !important;\n  padding-bottom: 7px !important;\n  border-bottom: none !important;\n  transition: background-color 180ms ease, color 180ms ease !important;\n  position: relative;\n}\n\n.MainMenuItem:hover {\n  background-color: rgba(140, 198, 62, 0.08) !important;\n  color: #ffffff !important;\n}\n\n.MainMenuItem.Mui-selected {\n  background-color: rgba(140, 198, 62, 0.16) !important;\n  color: #ffffff !important;\n}\n\n.MainMenuItem.Mui-selected:hover {\n  background-color: rgba(140, 198, 62, 0.22) !important;\n  color: #ffffff !important;\n}\n\n/* Acento verde a la izquierda del item activo */\n.MainMenuItem.Mui-selected::before {\n  content: '';\n  position: absolute;\n  top: 6px;\n  bottom: 6px;\n  left: 0;\n  width: 3px;\n  background-color: #8CC63E;\n  border-radius: 0 4px 4px 0;\n}\n\n.MainMenuItem .MuiListItemText-primary {\n  font-size: 0.85rem !important;\n  font-weight: 500 !important;\n}\n\n/* Iconos — color por sección, ver más abajo */\n.MainMenuItemIcon {\n  color: #8CC63E !important;\n  min-width: 38px !important;\n  transition: color 180ms ease, filter 180ms ease !important;\n}\n\n.MainMenu:hover .MainMenuItemIcon,\n.MainMenuItem:hover .MainMenuItemIcon {\n  filter: brightness(1.2);\n}\n\n/* Paleta por categoría (coincide con tarjetas de Inicio) */\n.cat-inicio .MainMenuItemIcon         { color: #8CC63E !important; }\n.cat-reportes .MainMenuItemIcon       { color: #6A9E2C !important; }\n.cat-transacciones .MainMenuItemIcon  { color: #7E57C2 !important; }\n.cat-monitoreo .MainMenuItemIcon      { color: #2E7DD7 !important; }\n.cat-cajeros .MainMenuItemIcon        { color: #E07A1F !important; }\n.cat-server .MainMenuItemIcon         { color: #00897B !important; }\n.cat-funcionarios .MainMenuItemIcon   { color: #78909C !important; }\n.cat-depositantes .MainMenuItemIcon   { color: #F4B400 !important; }\n.cat-billetera .MainMenuItemIcon      { color: #C2185B !important; }\n.cat-administracion .MainMenuItemIcon { color: #7E5BEF !important; }\n.cat-cuenta .MainMenuItemIcon         { color: #00ACC1 !important; }\n\n/* Divisores sutiles para las secciones (cuando MainLayout aplica borderTop inline) */\n.MainDrawer .MuiList-root[style*=\"border-top\"],\n.MainDrawer .MuiList-root[style*=\"border-bottom\"] {\n  border-color: rgba(255, 255, 255, 0.06) !important;\n}\n\n/* Chevrons de expandir/colapsar */\n.MainMenu .MuiSvgIcon-root[data-testid=\"ExpandMoreIcon\"],\n.MainMenu .MuiSvgIcon-root[data-testid=\"ExpandLessIcon\"] {\n  color: rgba(255, 255, 255, 0.4) !important;\n}\n\n/* Versión */\n.MainDrawerVersion {\n  color: rgba(255, 255, 255, 0.4) !important;\n  font-size: 0.72rem !important;\n  letter-spacing: 0.06em;\n  text-align: center;\n  padding: 12px 0 14px !important;\n  margin: 0 !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
